// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")
require("jquery")
require("jquery-ui")
require("../src/jquery.ui.touch-punch.min")
require("../src/jquery.validationEngine")
require("../src/jquery.validationEngine-ja")
require("../src/formvalidation")
require("../src/list_sort")

import "bootstrap"
import "../stylesheets/application"

require("../src/bootstrap4-toggle.min")
import "../stylesheets/bootstrap4-toggle.min"

require("../src/toggle")
require("../src/tooltip_setting")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

